import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/combineReducer";
import Dropdown from "./Dropdown";
import StyledWrapper from "./style";
import { Icon } from "../../core/Icon";
import { circleDown } from "react-icons-kit/icomoon";
import { removeTokensLocalStorage } from "../../../utils/auth/getTokensLocalStorage";

type MenuItem = {
  title: string;
  link?: string;
  imageURL?: string;
  submenu?: MenuItem[];
};

const MenuItems = ({ items, depthLevel, handleChosenCompany }: any) => {
  const [dropdown, setDropdown] = useState(false);

  const reduxStore = useSelector((state: RootState) => state.user);
  const [profile] = useState(reduxStore);

  let chosenCompany = reduxStore.currentCompany?.fantasyName;
  let ref: any = useRef();

  useEffect(() => {
    const handler = (event: Event) => {
      if (dropdown && ref.current && !ref?.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener("mousedown", handler);
    document.addEventListener("touchstart", handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", handler);
      document.removeEventListener("touchstart", handler);
    };
  }, [dropdown]);

  const logout = () => {
    removeTokensLocalStorage();
  };

  const onMouseEnter = () => {
    window.innerWidth > 960 && setDropdown(true);
  };

  const onMouseLeave = () => {
    window.innerWidth > 960 && setDropdown(false);
  };

  const handleClick = async (items: MenuItem) => {
    if (items.link === "/") {
      await logout();
    }
    handleChosenCompany(items);
  };

  return (
    <StyledWrapper.MenuItems
      ref={ref}
      onMouseLeave={onMouseLeave}
    >
      {items.imageURL && depthLevel === 0 && items.submenu ? (
        <>
          <div className="cursor-pointer" onClick={() => {
            onMouseEnter();
          }}>
            <div className="avatar-letters">
              <h1 className="text-uppercase">{profile?.name?.charAt(0)}</h1>
            </div>
            <Icon
              icon={circleDown}
              className="circleDown"
              style={{ color: 'red' }}
            />
          </div>
          <Dropdown
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
            handleChosenCompany={(items: any) => handleChosenCompany(items)}
          />
        </>
      ) : items.submenu ? (
        <>
          <StyledWrapper.DropDownButton
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? "true" : "false"}
            onClick={() => setDropdown((prev) => !prev)}
          >
            {depthLevel > 0 ? (
              <svg
                className="stroke-current h-4 w-2"
                viewBox="0 0 6 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  className="stroke-current"
                  d="M5 10L1 5.5L5 1"
                  stroke="stroke-current"
                  strokeLinecap="round"
                />
              </svg>
            ) : (
              <span className="arrow" />
            )}{" "}
            <span>{items.title}</span>{" "}
          </StyledWrapper.DropDownButton>
          <Dropdown
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
            handleChosenCompany={(items: any) => handleChosenCompany(items)}
          />
        </>
      ) : (
        <StyledWrapper.Links
          href={items.link ? items.link : "#"}
          onClick={() => {
            handleClick(items);
          }}
        >
          {chosenCompany === items.title && (
            <svg
              width="16"
              height="12"
              viewBox="0 0 16 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 7L5 11L15 1"
                stroke="#DD716F"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}{" "}
          <span>{items.title}</span>{" "}
        </StyledWrapper.Links>
      )}{" "}
    </StyledWrapper.MenuItems>
  );
};

export default MenuItems;
